import React, { useMemo } from 'react';
import { observer } from 'mobx-react';

import { dataControlStore } from '@stores/dataControlStore';

import { ControlLevelFilter } from './ControlLevelFilter';
import { GeneralReportFilter } from './GeneralReportFilter';
import { PackageLevelFilter } from './PackageLevelFilter';

export const Filters = observer(() => {
  const { lastPagesParam } = dataControlStore;

  const render = useMemo(() => {
    switch (lastPagesParam.controlType) {
      case 'generalReport':
        return <GeneralReportFilter />;
      case 'packageLevel':
        return <PackageLevelFilter />;
      case 'controlLevel':
        return <ControlLevelFilter />;

      default:
        return <div></div>;
    }
  }, [lastPagesParam.controlType]);

  return <>{render}</>;
});
